import Button from '@atlaskit/button';
import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import Tooltip from '@atlaskit/tooltip';
import { SendDatabaseCreatedViewEventData } from '@databases/analytics/src/types';
import { messages } from '@databases/views/messages';
import React, { FunctionComponent, useCallback } from 'react';
import { useIntl } from 'react-intl-next';

interface AddViewButtonProps {
  handleAddView: (source: SendDatabaseCreatedViewEventData['source']) => void;
}
const AddViewButton: FunctionComponent<AddViewButtonProps> = ({ handleAddView }) => {
  const { formatMessage } = useIntl();

  const handleClick = useCallback(() => {
    handleAddView('databaseViewTabs');
  }, [handleAddView]);

  return (
    <Tooltip position="bottom" content={formatMessage(messages['views.add-view-label'])}>
      <Button
        appearance="subtle"
        onClick={handleClick}
        iconBefore={
          <EditorAddIcon
            size="medium"
            label={formatMessage(messages['views.add-view-label'])}
          />
        }
        testId="add-view-button"
      />
    </Tooltip>
  );
};

export default AddViewButton;
